import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
// Component
import Text from "Components/FormControl/Text/Text";
import { useFormikContext } from "formik";
import React, { useContext, useEffect, useState } from "react";
// SCSS
import styles from "./tax.module.scss";
import { useOrderAttributeProvider } from "Pages/Order/Order/context/order";
import { AppContext } from "Context/AppContext";
import { calculateTaxRate } from "Context/OrderContext/OrderCalculation";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Tax = ({ showModal, pageTitle, handleCancelClick, submitStatus }) => {
  const formik = useFormikContext();
  const { summary } = useOrderAttributeProvider();
  const { showToastMessage } = useContext(AppContext);
  const [tax, setTax] = useState(
    formik.values.tax_amount ? formik.values.tax_amount : ""
  );

  useEffect(() => {
    setTax(formik.values.tax_amount ? formik.values.tax_amount : "");
  }, [formik.values.tax_amount]);

  const saveTax = () => {
    if (summary.sub_total <= 0) {
      showToastMessage(
        undefined,
        "Subtotal must be greater than 0",
        "error",
        false
      );
      handleCancelClick();
      setTax('');
      return;
    } else {
      const taxRate = calculateTaxRate(
        summary.sub_total - summary.discount_price,
        tax
      );
      formik.setValues((v) => {
        return {
          ...v,
          tax_amount: +Number(tax).toFixed(2),
          is_tax_calculated_manually: 1,
          tax_rate: taxRate,
          taxable_amount: summary.sub_total - summary.discount_price,
        };
      });
    }
    handleCancelClick();
  };

  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={`${styles.modalContent} px-0 py-0`}>
          <div className={`text-center ${styles.modalBody}`}>
            <h5 className={`my-3 text-center ${styles.modalTitle}`}>
              {pageTitle}
            </h5>
            <div className="row">
              <div
                className={`col-md-8 col-xs-12 mt-5 mb-5 ${styles.marginAuto}`}
              >
                <Text
                  type="text"
                  label="Tax"
                  value={tax}
                  required={true}
                  submitStatus={submitStatus}
                  onChange={(data) => {
                    // Validate for floating point numbers (both whole and decimal)
                    if (/^\d*\.?\d*$/.test(data)) {
                      // Only set the value if it's a valid number format
                      if (data === "" || data === ".") {
                        setTax(data);
                      } else {
                        const numValue = parseFloat(data);
                        if (!isNaN(numValue)) {
                          setTax(data);
                        }
                      }
                    }
                  }}
                />
              </div>
            </div>
            <span
              data-dismiss="modal"
              onClick={saveTax}
              className="btn gray-btn d-inline-block mt-5 mb-5 mr-2 mt-5 cursor-pointer"
            >
              Save
            </span>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default Tax;
